"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _objectSpread2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty3 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = _interopRequireDefault(require("@/components/Tinymce/index.vue"));
var _contentDefine = require("@/api/content-define.api");
var rule = {
  message: "Bắt buộc",
  required: true,
  trigger: "submit"
};
var ContentModal = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(ContentModal, _Vue);
  var _super = (0, _createSuper2.default)(ContentModal);
  function ContentModal() {
    var _defineProperty2;
    var _this;
    (0, _classCallCheck2.default)(this, ContentModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "visible", false);
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "form", {
      contentDefine: {}
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "status", "create");
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "rules", (_defineProperty2 = {}, (0, _defineProperty3.default)(_defineProperty2, "contentDefine.title", rule), (0, _defineProperty3.default)(_defineProperty2, "contentDefine.body", rule), _defineProperty2));
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "loading", false);
    return _this;
  }
  (0, _createClass2.default)(ContentModal, [{
    key: "onSubmitOk",
    value: function onSubmitOk() {
      return "";
    }
  }, {
    key: "setBody",
    value: function setBody() {
      this.$refs.editor.setContent(this.form.contentDefine.body);
    }
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$refs.form.validate();
              case 2:
                this.loading = true;
                _context.prev = 3;
                _context.next = 6;
                return _contentDefine.contentDefineApi.update(this.form.contentDefine.id, this.form);
              case 6:
                this.$notify({
                  title: "Thông báo",
                  message: "Cập nhật thành công",
                  type: "success"
                });
                this.visible = false;
                this.onSubmitOk();
              case 9:
                _context.prev = 9;
                this.loading = false;
                return _context.finish(9);
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3,, 9, 12]]);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "handleUpdate",
    value: function handleUpdate(data) {
      var _this2 = this;
      this.form = {
        contentDefine: (0, _objectSpread2.default)({}, data)
      };
      this.visible = true;
      this.status = "update";
      this.$nextTick(function () {
        if (_this2.$refs.editor.hasInit) {
          _this2.$refs["editor"].setContent(data.body);
        }
      });
    }
  }]);
  return ContentModal;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Emit)("submit:ok")], ContentModal.prototype, "onSubmitOk", null);
ContentModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    Tinymce: _index.default
  }
})], ContentModal);
var _default = ContentModal;
exports.default = _default;